<template>
<div class="imcLogin">
    <div class="main-login">
      <h1 class="big-font">深圳演示操作台</h1>
      <p>请输入回路id
        <el-input
          size="large"
        style="width: 220px;"
        v-model="branchId">
      </el-input>

      </p>
      <p style="margin-top: 40px">
        <el-button type="primary" style=" " @click="xllh('a')" > 线路老化(A) </el-button>
        <el-button type="primary" style="margin-left:20px; " @click="ldhj('s')" > 零地混接(S) </el-button>
      </p>
      <p style="margin-top: 40px">
        <el-button type="primary" style=" " @click="sxqy('d')" > 三相欠压告警(D) </el-button>
        <el-button type="primary" style="margin-left:20px; " @click="sxwd('f')" > 三相温度告警(F) </el-button>
      </p>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "orgpage",
  data() {
    return {
      branchId:"",

    };
  },
  methods: {
    uploadParams(){

    },
    changedata(data){

    },
    xllh(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/simulate/risk";
      param.data={
        "branchId":this.branchId,
        "alertLevel":"101",
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    ldhj(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/simulate/risk";
      param.data={
        "branchId":this.branchId,
        "alertLevel":"99",
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    sxqy(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/simulate/event";
      param.data={
        "branchId":this.branchId,
        "eventTypeId":"1",
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    sxwd(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/simulate/event";
      param.data={
        "branchId":this.branchId,
        "eventTypeId":"2",
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
  },
  mounted() {
    let that=this
    document.onkeydown = function (e) {
      var key = window.event.keyCode;

      if(key=='65'){
        that.xllh()
      }else if(key=='83'){
        that.ldhj()
      }else if(key=='68'){
        that.sxqy()
      }else if(key=='70'){
        that.sxwd()
      }
    };

  },
  watch:{

  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.imcLogin {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-login{
    width: 500px;
  margin: 100px auto;
  text-align: center;
.big-font{
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 40px;
}
  p{
    width: 100%;
  }
  .big-font{
    font-size: 20px;
    margin: 10px 0;
  }
}
</style>

